import { render, staticRenderFns } from "./search_card.vue?vue&type=template&id=56f4a29c&"
import script from "./search_card.vue?vue&type=script&lang=js&"
export * from "./search_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports